import ErrorComponent from "@/components/atoms/ErrorComponent";
import Loader from "@/components/atoms/Loader";
import { PaginateCardProps } from "@/interfaces/Card";
import { IFilters } from "@/interfaces/Fetch";
import {
  useDeleteUserNoteMutation,
  useGetUserNotesQuery,
} from "@/services/users/notes";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { ElementRef, FC, useEffect, useRef, useState } from "react";
import { ToastContentProps, toast } from "react-toastify";
import NotesCard from "../NotesCard";
import AreYouSurToContinueModal from "../../modals/AreYouSurToContinueModal";

const UserNotesCard: FC<PaginateCardProps & { id: string }> = ({
  id,
  onGetTotal,
}) => {
  const DeleteModalRef =
    useRef<ElementRef<typeof AreYouSurToContinueModal>>(null);
  const [filters, setFilters] = useState<IFilters>({
    pageIndex: 0,
    pageSize: 10,
  });

  const { data, isLoading, isError, error } = useGetUserNotesQuery([
    id,
    filters,
  ]);
  const [deleteUserNoteAsync] = useDeleteUserNoteMutation();

  const onDeleteNote = (noteId: string) => {
    toast.promise(deleteUserNoteAsync([id, noteId]).unwrap(), {
      pending: "Suppression de la note en cours...",
      success: {
        render() {
          DeleteModalRef.current?.showOrHiddenModal();
          return (
            <p style={{ marginBottom: 0, textAlign: "center" }}>
              La note à bien été supprimée 🤩
            </p>
          );
        },
      },
      error: {
        render({ data }: ToastContentProps<FetchBaseQueryError>) {
          if (data?.status === 422) {
            return "Les champs que vous avez remplis semblent être incorrects.";
          }

          return "Une erreur est survenue";
        },
      },
    });
  };

  useEffect(() => {
    data?.meta && onGetTotal?.(data.meta.total);
  }, [data?.meta]);

  if (isLoading) {
    return <Loader absolute />;
  } else if (isError) {
    return <ErrorComponent error={error} absolute returnButton />;
  }

  return (
    <div>
      <AreYouSurToContinueModal
        ref={DeleteModalRef}
        onContinue={onDeleteNote}
        title="Souhaitez-vous vraiment supprimé le statut de la entreprise qui a pour id : {{id}} ?"
      />
      <NotesCard
        data={data?.data}
        meta={data?.meta}
        filters={filters}
        setFilters={setFilters}
        onRemove={(id) => DeleteModalRef.current?.showOrHiddenModal(id)}
      />
    </div>
  );
};

export default UserNotesCard;
